import { render, staticRenderFns } from "./aside-calendar-svg.vue?vue&type=template&id=5b3abc1e&scoped=true"
import script from "./aside-calendar-svg.vue?vue&type=script&lang=js"
export * from "./aside-calendar-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3abc1e",
  null
  
)

export default component.exports